import React from 'react';
import PropTypes from 'prop-types';
import './AuthenticationPage.css';

function Team({ uuid, logo, onClick, name, isClicked }) {
  return (
    <img
      id={uuid}
      className={`logoTeam ${isClicked ? 'logoTeamColor' : 'logoTeamSepia'}`}
      src={logo}
      alt={name}
      onClick={e => onClick(e, logo)}
    />
  );
}

export default Team;

Team.propTypes = {
  uuid: PropTypes.string.isRequired, // THIS IS AN UUIDV4
  logo: PropTypes.string.isRequired, // THIS IS A IMG URL
  onClick: PropTypes.func.isRequired,
  name: PropTypes.string // If PropTypes not required, add a defaultProps
};

Team.defaultProps = {
  name: ''
};
